export const API_BASE = process.env.OMNIPLATFORM_API;
export const API_PATH = 'onboarding-progress';

export enum EmployeeStepIds {
  COMPENSATION_REVIEWED = '4AfCOdtepyH5tOwloWBG1T',
}
